module.exports = __webpack_public_path__ + "img/logo.3a2906c3.png";